import { logCoreUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';

// Leaf module intentionally kept free of store/session/feature-flag imports so cross-bundle
// callers (e.g. owa-copilot-dab-mail) that only need id/type reconciliation don't eagerly
// pull the heavier telemetry graph in logEvent.ts into their bundle.

/**
 * Returns the kind of mismatch when the EWS id prefix clearly disagrees with the
 * annotation type, or undefined when the id format is inconclusive (e.g. immutable ids
 * or non-EWS formats — we'd rather miss a mismatch than report a false positive).
 *  - 'AAMk' → Message item id
 *  - 'AAQk' → Conversation id
 */
export type SummarizeAnnotationIdTypeMismatch =
    | 'messageIdTaggedAsEmailConversation'
    | 'conversationIdTaggedAsMessage';

export function detectSummarizeAnnotationIdTypeMismatch(
    annotationType: string,
    id: string | undefined
): SummarizeAnnotationIdTypeMismatch | undefined {
    if (!id) {
        return undefined;
    }
    if (annotationType === 'EmailConversation' && id.startsWith('AAMk')) {
        return 'messageIdTaggedAsEmailConversation';
    }
    if (annotationType === 'Message' && id.startsWith('AAQk')) {
        return 'conversationIdTaggedAsMessage';
    }
    return undefined;
}

export function logSummarizeAnnotationIdTypeMismatch(
    mailboxInfo: MailboxInfo,
    source: string,
    mismatch: SummarizeAnnotationIdTypeMismatch
): void {
    logCoreUsage('ThreadSummarization_MismatchedAnnotationIdType', mailboxInfo, {
        source,
        mismatch,
    });
}

export function logReconciledAnnotationIdType(
    mailboxInfo: MailboxInfo,
    source: string,
    mismatch: SummarizeAnnotationIdTypeMismatch
): void {
    logCoreUsage('ThreadSummarization_ReconciledAnnotationIdType', mailboxInfo, {
        source,
        mismatch,
    });
}
